import type { ProjectPassport } from "../types";

export const projectPassport: ProjectPassport = {
  lastUpdatedAt: "2026-07-15",
  names: {
    official: "Social by AKFA",
    ru: "Social by AKFA",
    uz: "Social by AKFA",
    en: "Social by AKFA",
    short: "Social",
    allowedMention: "Social by AKFA",
    prohibitedVariants: ["AKFA Social Clinic", "AKFA Medline Social", "Social AKFA"],
  },
  shortDescription:
    "Social by AKFA — крупный социальный диагностический и амбулаторный медицинский центр, создаваемый в Ташкенте для развития доступной и современной медицинской помощи в Узбекистане.",
  fullDescription:
    "Social by AKFA — крупный социальный диагностический и амбулаторный медицинский центр, создаваемый в Ташкенте для развития доступной и современной медицинской помощи в Узбекистане. Проект реализуется AKFA Group в партнёрстве с Central Asian University и AKFA Medline University Hospital и ориентирован на оказание первичной медицинской помощи с использованием современных диагностических технологий, цифровых сервисов и международных стандартов организации медицинской помощи.",
  fullDescriptionNote:
    "Текст требует финальной проверки перед использованием в официальных материалах, если данные о партнёрах или формулировки изменятся.",
  mission:
    "Развивать доступную, современную и пациент-ориентированную медицинскую помощь, в которой здоровье рассматривается не как привилегия, а как право.",
  principle: "Люди прежде всего.",
  supportingPrinciple: "Здоровье — не привилегия, а право.",
  projectTypes: [
    "социальный медицинский проект",
    "диагностический центр",
    "амбулаторная медицинская помощь",
    "первичная медицинская помощь",
    "цифровая медицина",
    "профилактическая медицина",
    "медицинское образование",
    "patient-oriented healthcare",
  ],
  directions: [
    { title: "Первичная медицинская помощь", description: "Первичная оценка состояния здоровья и понятный маршрут пациента." },
    { title: "Амбулаторный приём", description: "Консультации и лечение без госпитализации." },
    { title: "Современная диагностика", description: "Лабораторные, инструментальные и визуализационные исследования." },
    { title: "Профилактика заболеваний", description: "Раннее выявление рисков и профилактические обследования." },
    { title: "Цифровые сервисы", description: "Единая цифровая среда для удобного пути пациента." },
    { title: "Медицинская навигация", description: "Понятное сопровождение между этапами медицинской помощи." },
    { title: "Стандартизация процессов", description: "Единые принципы работы медицинской команды." },
    { title: "Подготовка и отбор врачей", description: "Практическая оценка профессиональной готовности специалистов." },
    { title: "Клинические симуляции", description: "Сценарии, приближённые к реальному медицинскому приёму." },
    { title: "Patient flow", description: "Анализ движения пациента для более удобной организации помощи." },
  ],
  audiences: [
    { title: "Жители Ташкента и Узбекистана", description: "Люди, которым необходима доступная амбулаторная и диагностическая медицинская помощь." },
    { title: "Семьи с детьми", description: "Пациенты, которым важны удобство, понятный маршрут, профилактика и комплексное медицинское сопровождение." },
    {
      title: "Взрослые и люди старшего возраста",
      description: "Пациенты, которым необходимы консультации, диагностика, обследования и профилактические программы, а также понятная навигация, доступность и последовательное сопровождение.",
    },
    { title: "Врачи и медицинские специалисты", description: "Потенциальные сотрудники, участники SPS, эксперты и представители медицинского сообщества." },
    { title: "Студенты и выпускники", description: "Будущие специалисты, которые могут участвовать в отборе, обучении и профессиональном развитии." },
    { title: "Партнёры и профессиональное сообщество", description: "Медицинские организации, университеты, эксперты, СМИ и потенциальные партнёры проекта." },
  ],
  features: [
    "Масштаб проекта",
    "Доступность медицинской помощи",
    "Современная диагностика",
    "Цифровые сервисы",
    "Patient-oriented подход",
    "Единые стандарты работы",
    "Связь с медицинским образованием",
    "Практический отбор врачей",
    "Анализ patient flow",
    "Потенциал масштабирования",
  ],
  organizations: [
    {
      title: "AKFA Group",
      description: "Организация, реализующая проект Social by AKFA.",
      verification: "confirmed",
    },
    {
      title: "Central Asian University",
      description: "Образовательный партнёр, указанный в материалах проекта.",
      verification: "confirmed",
    },
    {
      title: "AKFA Medline University Hospital",
      description: "Медицинский партнёр, указанный в материалах проекта.",
      verification: "confirmed",
    },
  ],
  currentStatus: {
    status: "Подготовка к запуску",
    stage: "Предзапусковой этап",
    updatedAt: "2026-07-15",
    note: "Проект находится на этапе подготовки к запуску. Информация о сроках открытия должна использоваться только после официального подтверждения.",
  },
};
